import { COLOR } from 'vars/color'

export const NavGroupGap = {
  SIZE_0: '0px',
  SIZE_8: '8px',
  SIZE_16: '16px',
  SIZE_32: '32px',
} as const
export type NavGroupGap = (typeof NavGroupGap)[keyof typeof NavGroupGap]

export const NavAlignItems = {
  FlexStart: 'flex-start',
  Center: 'center',
  FlexEnd: 'flex-end',
} as const
export type NavAlignItems = (typeof NavAlignItems)[keyof typeof NavAlignItems]

export const NavJustifyContent = {
  FlexStart: 'flex-start',
  Center: 'center',
  FlexEnd: 'flex-end',
  SpaceBetween: 'space-between',
  SpaceAround: 'space-around',
  SpaceEvenly: 'space-evenly',
} as const
export type NavJustifyContent =
  (typeof NavJustifyContent)[keyof typeof NavJustifyContent]

export const NavBackground = {
  TRANSPARENT: COLOR.TRANSPARENT,
  SURFACE_OPACITY_LIGHT_10: COLOR.SURFACE_OPACITY_LIGHT_10,
  SURFACE_OPACITY_LIGHT_15: COLOR.SURFACE_OPACITY_LIGHT_15,
  SURFACE_OPACITY_LIGHT_20: COLOR.SURFACE_OPACITY_LIGHT_20,
  TEXT_ICON_TERTIARY: COLOR.TEXT_ICON_TERTIARY,
} as const
export type NavBackground = (typeof NavBackground)[keyof typeof NavBackground]
